<template>
  <v-container>
    <h3>Detalle Movimiento</h3>
    <br />
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>¿Cómo Visualizar el Detalle de un Movimiento?</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <h4>Pasos:</h4>
          <ul>
            <li>
              Hacer click en el ícono en la columna <b> "Ver Detalle"</b>.
            </li>
          </ul>
          <br />
          <h4>Ejemplo:</h4>
          <v-img
            contain
            max-height="500"
            max-width="1000"
            src="../assets/SeeComprobante.png"
          ></v-img>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>
            ¿Cómo Descargar un Comprobante de Pago, Factura en PDF o Factura en
            XML?
          </h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <h4>Pasos:</h4>
          <ul>
            <li>
              Hacer click en el ícono de <b> "Complemento"</b>,
              <b>"FACTURA(PDF)"</b>, <b>"FACTURA(XML)"</b>, según el documento
              que se necesite descargar.
            </li>
          </ul>
          <br />
          <h4>Ejemplo:</h4>
          <v-img
            contain
            max-height="500"
            max-width="1000"
            src="../assets/DownloadComprobante.png"
          ></v-img>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>¿Cómo Registrar un Complemento de Pago?</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <br />
          <h4>Glosario:</h4>
          <ul>
            <li>
              <b>Fecha de pago</b> se refiere a la fecha en que se pagó el
              producto.
            </li>
            <li>
              <b>RFC</b> se refiere al RFC del cliente al que se le vendió.
            </li>
            <li><b>Monto</b> se refiere al total de la factura.</li>
            <li>
              <b>Método de pago</b> hace referencia al momento en que la
              operación es liquidada.
            </li>
            <li>
              <b>Forma de pago</b> son los distintos medios a través de los
              cuales se pueden pagar los productos adquiridos o servicios
              recibidos.
            </li>
            <li>
              <b>RFC banco del cliente</b> se refiere al RFC del banco que fue
              encargado de transferir ese dinero.
            </li>
            <li>
              <b>Cuenta del cliente</b> se refiere al número de cuenta del
              cliente.
            </li>
            <li>
              <b>Número de operación</b> puede ser el número de cheque,
              referencia, clave de rastreo, o alguna otra referencia que
              identifique la operación del pago.
            </li>
            <li>
              <b>Nombre banco cliente</b> se refiere al nombre comercial del
              banco del cliente.
            </li>
            <li>
              <b>Folio</b> es un número de uso interno que sirve para
              identificar el comprobante de pago.
            </li>
            <li>
              <b>No. Parcialidad</b> se refiere a la parcialidad a la que
              corresponde el pago.
            </li>
            <li>
              <b>Importe de saldo anterior</b> se refiere al saldo que falta por
              pagar, si esta es la primer parcialidad deberá ser el saldo total
              de este documento, por consiguiente, en las siguientes
              parcialidades este valor será menor.
            </li>
            <li>
              <b>Importe pagado</b> se refiere al monto pagado, debe de ser
              menor o igual al importe de saldo anterior.
            </li>
            <li>
              <b>Saldo insoluto</b> se refiere a la diferencia entre el importe
              del saldo anterior y el importe pagado.
            </li>
          </ul>
          <br />
          <h4>Pasos:</h4>
          <ol>
            <li>
              En el calendario de <b>"Fecha de Pago"</b> seleccionar la fecha
              correspondiente.
            </li>
            <li>
              Los campos de <b>"RFC"</b> y <b>"Monto" </b>serán llenados por el
              sistema.
            </li>
            <li>
              Hacer click sobre <b>"Método de pago"</b> para desplegar las
              opciones de métodos de pago y seleccionar el correspondiente.
            </li>
            <li>
              Hacer click sobre <b>"Forma de pago"</b> para desplegar las
              opciones formas de pago y seleccionar la correspondiente.
            </li>
            <li>
              Los campos de
              <b>"RFC Banco del Cliente", "Cuenta del Cliente" </b> y
              <b>"Nombre banco cliente" </b>serán llenados por el sistema.
            </li>
            <li>Llenar el campo <b> "Número de operación"</b>.</li>
            <li>Llenar el campo <b> "Folio"</b>.</li>
            <li>Llenar el campo <b> "No. parcialidad"</b>.</li>
            <li>
              El campo <b>"Importe de saldo anterior"</b> será llenado por el
              sistema. En caso de <b>NO</b> ser el primer complemento cambiar el
              importe según lo correspondiente.
            </li>
            <li>Llenar el campo <b> "Importe Pagado"</b>.</li>
            <li>
              El campo <b>"Saldo Absoluto" </b>será llenado por el sistema.
            </li>
            <li>Verificar que todos los campos estén correctos.</li>
            <li>Hacer click en el botón <b>FACTURAR COMPLEMENTO</b>.</li>
          </ol>
          <br />
          <h4>Ejemplo:</h4>
          <v-img
            contain
            max-height="1000"
            max-width="1000"
            src="../assets/RegisterMovement.png"
          ></v-img>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
export default {
  name: "DocsMovements",

  data: () => ({}),
};
</script>
